<template>
    <div class="container-bankAdd">
        <VerificationWaiting
            v-if="isWaiting"
            :message="waitingMessage"
        />
        <Success
            v-if="isSuccess"
        />
        <FailureDialog
            v-if="isFailure"
            :message="failureMessage"
            @handleClose="handleCloseFailure"
        />
        <link rel="preconnect" href="https://fonts.googleapis.com">
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
        <link href="https://fonts.googleapis.com/css2?family=Inter&display=swap" rel="stylesheet">
        <div class="container-local" v-if="!isWaiting && !isSuccess">
            <button class = "back_image">
                <img src = "/img/arrow_back.svg" @click="goBack"/>
            </button>
            <div class="main-content">
                <div class="bank-add">
                    <span class="heading">
                        Add your bank details
                    </span>
                    <p class="semi-heading">From which you will transact funds to invest.</p>
                </div>
                <div class="form">
                    <ValidationObserver v-slot="{ invalid }">
                        <p class="form-heading">Account Number</p>
                        <ValidationProvider
                            name="Account Number"
                            vid="Account Number"
                            rules="required|numeric"
                            v-slot="{ errors }"
                        >
                            <div class="single-field" >
                                <div class="bank-logo">
                                    <img src = "/img/Bank-Blue.jpg"/>
                                </div>
                                <div class="verticalLine"></div>
                                <input
                                    v-model="accountNo"
                                    placeholder="123456789012"
                                >
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>
                        </ValidationProvider>
                        <p class="form-heading">Confirm Account Number</p>
                        <ValidationProvider
                            name="Confirm Account Number"
                            rules="required|numeric|equal:@Account Number,Account Number"
                            v-slot="{ errors }"
                        >
                            <div class="single-field">
                                <div class="bank-logo">
                                    <img src = "/img/Bank-Blue.jpg"/>
                                </div>
                                <div class="verticalLine"></div>
                                <input
                                    v-model="confirmAccountNo"
                                    placeholder="123456789012"
                                >
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>
                        </ValidationProvider>
                        <p class="form-heading">IFSC</p>
                        <ValidationProvider
                            name="IFSC Code"
                            rules="required|alpha_num|length:11"
                            v-slot="{ errors }"
                        >
                            <div class="single-field">
                                <div class="bank-logo">
                                    <img src = "/img/IFSC.png"/>
                                </div>
                                <div class="verticalLine"></div>
                                <input
                                    v-model="ifsc"
                                    placeholder="YESB0000000"
                                    oninput="this.value = this.value.toUpperCase();"
                                    maxLength="11"
                                    type="text"
                                >
                            </div>
                            <small class="form-group--error-message">{{ errors[0] }}</small>
                        </ValidationProvider>
                        <div class="submit-div">
                            <button :disabled="invalid" class="submit" @click="goNext">
                                Next
                            </button>
                        </div>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VerificationWaiting from './waiting.vue'
import Success from './success.vue'
import FailureDialog from './failure.vue'
import LenderService from '@/services/lenderService'

export default {
    name: 'addBankAccountDetails',
    components: {
        VerificationWaiting,
        Success,
        FailureDialog
    },
    props: {
        onBoardingComponent: Boolean
    },
    data: () => ({
        accountNo: '',
        confirmAccountNo: '',
        ifsc: '',
        isWaiting: false,
        isSuccess: false,
        isFailure: false,
        waitingMessage: '',
        failureMessage: ''
    }),
    methods: {
        goBack () {
            this.$emit('closeAddBankDetails')
        },
        async goNext () {
            this.isWaiting = true
            this.waitingMessage = 'We are verifying your account'
            const payload = {
                bankAccountNumber: this.accountNo,
                ifsc: this.ifsc,
                consent: 'Y'
            }
            const response = await LenderService.addBankAccount(payload)
            if (response.status === 200) {
                this.isWaiting = false
                this.isSuccess = true
                if (this.onBoardingComponent) {
                    this.$store.dispatch('onBoarding/setField', { field: 'Bank Account Number', value: this.accountNo })
                }
                setTimeout(() => {
                    this.handleSuccessClose()
                }, 3000)
            } else {
                if (response.status === 409) {
                    console.log(response)
                    this.failureMessage = 'Bank already exists, please try with different Bank Account'
                } else {
                    this.failureMessage = 'Currently we are facing some technical issue in verifying details.'
                }
                this.isWaiting = false
                this.isFailure = true
                setTimeout(() => {
                    this.handleCloseFailure()
                }, 5000)
            }
        },
        handleCloseFailure () {
            this.isFailure = false
        },
        handleSuccessClose () {
            this.isSuccess = false
            this.$emit('closeAddBankDetails')
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/components/dashboard/dashboard.scss";
::placeholder {
    color: #9E9E9E;
}

button:disabled,
button[disabled]{
    background-color: #002FA74D;
}
.container-local {
    width: 60% !important;
    align-items: center;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
}
.container-bankAdd {
    height: 100%;
    justify-content: center !important;
    display: flex;
    margin: 0px !important;
    padding: 0px !important;
    width: 100%;
}
.main-content {
    width: 100%;
    display: block;
    margin-left: 5%;
}
.heading {
    font-family: Inter;
    font-size: 22px;
    font-weight: 500;
    line-height: 27px;
    letter-spacing: 0em;
    text-align: left;
}
.addButton {
    font-family: 'Inter', sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 150%;
    display: inline-flex;
    align-items: right !important;
    text-align: right;
    float: right;
    letter-spacing: 0.005em;

    color: #002FA7;
    border: solid #002FA7 2px;
    padding: 7px 14px;
    border-radius: 8px;

}
.bank-details{
    margin-top: 62px;
    background-color: #F1F7FF;
    height:150px;
    display: flex;
    height: auto;
    padding: 20px;
    width:100%;
}
.bank-logo {
    background-color:#F6FAFF;
    display: flex;
    height: auto;
    width: 47px;
    align-items:center;
    justify-content:center;
}
.dots {
    background-color:#FFFFFF;
    width: 24px;
    height: 24px;
    display: flex;
    align-items:center;
    justify-content:center;
    margin-top: 1px;
     margin-right: 2px;
     position:absolute;
     top:0;
     right:0;
}
.bank-name {
    font-weight: 600;
    font-size: 21px;
    line-height: 100%;
}
.account-no {
    font-size: 17px;
    color: rgba(31, 31, 31, 0.5);;
}
.primary-bank {
    color: #007AFF;
    font-size: 13px;
    line-height: 16px;
    font-weight: 600;
}
.bank {
    width:60px;
    justify-content: center;
    display: flex;
    align-items: center;
}
p {
    margin:0px;
}
.data-bank {
    justify-content: center;
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
}
.verified {
    margin-top: 17px;
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: 0.005em;
    text-align: left;
    color: #1F1F1F80;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    img {
        padding-right:5px;
    }
}
.semi-heading{
    color: #6A6A6A;
    font-family: Inter;
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0em;
    text-align: left;
    display: block;
}
.form-heading {
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0em;
    text-align: left;
    color:#0F0F0F;
    margin-top: 24px;
}
.form {
    margin-top: 56px;
    align-items: center;
    justify-content: center;
}
.single-field {
    margin-top:4px;
    display: flex;
    background: #F6FAFF;
    border: solid #C8DEFF 1px;
    border-radius: 6px;
    height: 46px;
    align-items: center;
    margin-bottom: 0px;
}
input {
    width : 100%;
    padding-left : 11px;
    padding-right : 11px;
}
.verticalLine {
    border-left: 1px solid  #C8DEFF;
    height: 32px;
}
.submit {
    background-color: #002FA7;
    border-radius: 6px;
    height: 50px;
    width: 40%;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 16px;
    line-height: 150%;
}
.submit-div {
    margin-top: 122px;
    justify-content: center;
    display: flex;
}
.back_image {
    margin-top: 6px;
}
@media (max-width: 480px) {
    .form {
        margin-top : 36px;
    }
    .container-local {
        width: 100% !important;
        flex-direction: column;
        justify-content: flex-start;
    }
    .container {
        margin-top:10px;
        padding: 0px !important;
    }
    .main-content {
        margin: 20px !important;
        width: -webkit-fill-available;
    }
    .back_image {
        margin-left: 20px;
    }
    .submit {
        width: 80%;
    }
}

@media (min-width: 481px) and (max-width: 767px){
    .container-local {
        width: 90% !important;
    }
}
</style>
